<template>
  <nav aria-label="breadcrumb">
    <ol class="px-0 pt-1 pb-0 mb-0 bg-transparent breadcrumb" :class="stIsRTL ? '' : ' me-sm-6'">
      <li class="text-sm breadcrumb-item" :class="color">
        <a v-if="stIsRTL" :class="color" class="opacity-5 ps-2" href="#">لوحات القيادة</a>
        <a v-else :class="color" class="opacity-8" href="#">Pages</a>
      </li>
      <li class="text-sm breadcrumb-item active" :class="color" aria-current="page">
        {{ capitalizeFirstLetter(currentPage) }}
      </li>
    </ol>
    <!-- <h6 class="mb-0 font-weight-bolder" :class="color">
      {{ currentPage }}
    </h6> -->
  </nav>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "breadcrumbs",
  props: {
    currentPage: {
      type: String,
      required: "",
    },
    color: {
      type: String,
      default: "text-dark",
    },
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string?.charAt(0).toUpperCase() + string?.slice(1);
    }
  },
  computed: {
    // ...mapState(["isRTL"]),
    ...mapGetters(["stIsRTL"]),
  },
};
</script>
